if (!customElements.get('rococo-color-selector')) {
  customElements.define(
    'rococo-color-selector',
    class RococoColorSelector extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (!this.dataset.productTags.includes('colori-rococo')) return;

        this.productId = this.dataset.productId;
        this.storageKey = `rococo-color-selection-${this.productId}`;
        
        this.colorTableUrl = this.dataset.colorTableUrl;
        this.assetBaseUrl = this.colorTableUrl.substring(0, this.colorTableUrl.lastIndexOf('/') + 1);
        this.colorData = null;

        // Elementi UI
        this.inputGroup = this.querySelector('.rococo-input-group');
        this.colorInputDisplay = this.querySelector('.rococo-color-display');
        this.colorInputReal = this.querySelector('.rococo-color-real');
        this.surchargeInput = this.querySelector('.rococo-surcharge-variant-id');
        this.selectedPreviewContainer = this.querySelector('.rococo-selected-preview');
        this.toggleBtn = this.querySelector('.rococo-toggle-btn');
        this.clearBtn = this.querySelector('.rococo-clear-btn');
        
        // Elementi Modale
        this.modalOverlay = this.querySelector('.rococo-modal-overlay');
        this.modalCloseBtn = this.querySelector('.rococo-modal-close');
        this.colorSwatchContainer = this.querySelector('.color-swatch-container');

        this.initialize();
      }

      async initialize() {
        this.setupEventListeners();
        
        // Inizializza il Price Manager
        if (window.RococoPriceManager) {
            window.RococoPriceManager.init();
        }

        try {
          await this.fetchColorData();
          this.renderColorSwatches();
          this.restoreSelection();
          this.updateToggleButton();
        } catch (error) {
          console.error('Rococo Color Selector: Initialization failed', error);
          if (this.toggleBtn) this.toggleBtn.textContent = 'Errore nel caricamento dati';
        }
      }

      async fetchColorData() {
        if (this.colorData) return;
        try {
          const response = await fetch(this.colorTableUrl);
          if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
          this.colorData = await response.json();
        } catch (error) {
          console.error('Error fetching color data:', error);
          throw error;
        }
      }

      setupEventListeners() {
        this.toggleBtn.addEventListener('click', () => this.openModal());
        this.modalCloseBtn.addEventListener('click', () => this.closeModal());
        this.modalOverlay.addEventListener('click', (event) => {
          if (event.target === this.modalOverlay) this.closeModal();
        });

        this.clearBtn.addEventListener('click', () => this.clearSelection());

        this.colorSwatchContainer.addEventListener('click', (event) => {
          const swatch = event.target.closest('.color-swatch');
          if (swatch) {
            this.updateSelection(swatch.dataset.colorName);
            this.closeModal();
          }
        });
        
        // Ascolta il cambio variante per aggiornare il sovrapprezzo se necessario
        document.addEventListener('rococo:variant-change', () => {
            const currentColor = this.colorInputReal.value;
            if (currentColor) {
                this.updateSurcharge(currentColor);
            }
        });
      }
      
      updateSelection(colorName) {
        if (!this.colorData) return;
        
        const color = this.colorData.colori.find(c => c.codice === colorName);
        if (!color) {
          console.warn(`[Rococo] Colore ${colorName} non trovato.`);
          return;
        }

        this.colorInputReal.value = colorName;
        sessionStorage.setItem(this.storageKey, colorName);
        this.renderSelectedPreview(colorName);
        this.inputGroup.classList.add('has-selection');

        this.updateSurcharge(colorName);
      }

      updateSurcharge(colorName) {
        if (!window.RococoSurchargeHandler) return;

        const color = this.colorData.colori.find(c => c.codice === colorName);
        if (!color) return;

        const variantSelector = document.getElementById(this.closest('section').querySelector('.product-variant-selects').id);
        // Cerca input checked (radio) o option checked (select)
        const selectedOption = variantSelector.querySelector('input:checked, option:checked');
        // Se è una select, il value è diretto, se è radio, il value è nell'attributo value
        const variantTitle = selectedOption ? (selectedOption.value || selectedOption.text) : '';
        
        const surchargeId = window.RococoSurchargeHandler.getSurchargeVariantId(color.bucket, variantTitle);
        this.surchargeInput.value = surchargeId || '';
        
        // Salva metadati per il carrello
        this.surchargeInput.dataset.bucket = color.bucket;
        
        // Aggiorna il prezzo visivo e recupera il prezzo in euro
        if (window.RococoPriceManager) {
            window.RococoPriceManager.updateSurcharge(surchargeId);
            // Recupera il prezzo del sovrapprezzo dal manager per salvarlo nel dataset
            const surchargeCents = window.RococoPriceManager.surchargePrices[surchargeId] || 0;
            this.surchargeInput.dataset.surchargeEur = (surchargeCents / 100).toFixed(2) + ' €';
        }
      }

      clearSelection() {
        this.colorInputReal.value = '';
        this.surchargeInput.value = '';
        // Pulisci anche i dataset
        delete this.surchargeInput.dataset.bucket;
        delete this.surchargeInput.dataset.surchargeEur;

        sessionStorage.removeItem(this.storageKey);
        this.selectedPreviewContainer.innerHTML = '';
        this.inputGroup.classList.remove('has-selection');
        
        // Resetta il prezzo visivo
        if (window.RococoPriceManager) {
            window.RococoPriceManager.resetSurcharge();
        }
      }

      restoreSelection() {
        const savedColor = sessionStorage.getItem(this.storageKey);
        if (savedColor && this.colorData) {
           this.updateSelection(savedColor);
        }
      }

      renderSelectedPreview(colorName) {
        const color = this.colorData.colori.find(c => c.codice === colorName);
        if (!color) return;

        const imageUrl = this.assetBaseUrl + color.path;
        this.selectedPreviewContainer.innerHTML = `
            <div class="color-swatch" style="background-image: url('${imageUrl}'); width: 100%; height: 100%; cursor: default;" title="${color.codice}">
                <div class="color-swatch-inner" style="width: 100%;">
                    ${color.codice}
                </div>
            </div>
        `;
      }

      updateToggleButton() {
        this.toggleBtn.textContent = 'Mostra Tabella Colori';
        this.toggleBtn.disabled = false;
      }

      openModal() {
        if (!this.modalOverlay) return;
        document.body.style.overflow = 'hidden';
        this.modalOverlay.classList.add('is-visible');
      }

      closeModal() {
        if (!this.modalOverlay) return;
        document.body.style.overflow = '';
        this.modalOverlay.classList.remove('is-visible');
      }

      renderColorSwatches() {
        if (!this.colorData || !this.colorSwatchContainer) return;

        const colors = this.colorData.colori;
        this.colorSwatchContainer.innerHTML = '';

        if (colors.length === 0) {
          this.colorSwatchContainer.innerHTML = '<p style="padding:10px; width:100%;">Nessun colore trovato.</p>';
          return;
        }

        colors.forEach((color) => {
          const swatch = document.createElement('div');
          swatch.className = 'color-swatch';
          
          const imageUrl = this.assetBaseUrl + color.path;
          swatch.style.backgroundImage = `url('${imageUrl}')`;

          swatch.dataset.colorName = color.codice;
          swatch.title = `${color.codice}`;

          const swatchInner = document.createElement('div');
          swatchInner.className = 'color-swatch-inner';
          swatchInner.innerHTML = `
            ${color.codice}
          `;
          swatch.appendChild(swatchInner);

          this.colorSwatchContainer.appendChild(swatch);
        });
      }
    }
  );
}
